<template>
    <div class="app-wrapper allocation" :class="classObj">
        <el-container>
            <el-aside
                style="background-color: rgb(238, 241, 246)"
            >
                <sidebar class="sidebar-container" />
            </el-aside>
            <el-container>
                <app-main />
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { AppMain, Sidebar } from "./components";
import ResizeMixin from '../../layout/mixin/resize-handler.js';
import { mapGetters } from "vuex";

export default {
    name: "Layout",
    components: {
        AppMain,
        Sidebar
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapGetters(["sidebar","device"]),
        classObj() {
            return {
                // hideSidebar: !this.sidebar.opened,
                // openSidebar: this.sidebar.opened,
                // withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile',
                // sidebarcollapsed: !this.sidebar.opened
            };
        }
    }
};
</script>
